// extracted by mini-css-extract-plugin
export var container = "_ny-0";
export var dotAnimation = "_ny-2";
export var dotsLoading = "_ny-1";